import { useState } from "react";
import { cloneDeep } from "lodash";

import { defaultMessages, messagesType, commonErrorCode } from "utils/message.util";

const useMessage = () => {
  const [messages, setMessages] = useState(cloneDeep(defaultMessages));

  const resetMessages = (type) => {
    if (!type) {
      setMessages(cloneDeep(defaultMessages));
    } else {
      setMessages({ ...cloneDeep(defaultMessages), [type]: null });
    }
  }

  const setSuccessMessage = (successCode) => {
    setMessages({ ...cloneDeep(defaultMessages), error: successCode });
  }

  const setErrorMessage = (errorCode) => {
    setMessages({ ...cloneDeep(defaultMessages), error: errorCode });
  }

  const setWarningMessage = (hashCode) => {
    setMessages({ ...cloneDeep(defaultMessages), warning: hashCode });
  }

  return {
    messages,
    messagesType,
    commonErrorCode,
    resetMessages,
    setSuccessMessage,
    setErrorMessage,
    setWarningMessage
  };
}

export default useMessage;